import script from "./j-bread.vue?vue&type=script&lang=js"
export * from "./j-bread.vue?vue&type=script&lang=js"

import "./j-bread.vue?vue&type=style&index=0&id=60107c10&lang=less"

const __exports__ = script;

export default __exports__